<template>
    <div class="main-container">
      <b-card class="Export-container">
          <div class="Header">
            <b-row g="6">
              <b-col class="col-12 col-md-8">
                <b-row class="align-items-center"> 
                  <b-button @click="goToListLive" variant="light">
                    <font-awesome-icon :icon="['fas', 'arrow-left']" />
                  </b-button>
            <span class="header-title">{{ $t('table.list.subscribersList') }}</span></b-row>
          </b-col>
            <b-col class="col-6 col-md-4 col-sm-12 col-12 input-search">
              <b-row class="flex-nowrap right-content">
              <b-input-group size="lg" class="mb-2">
                <b-input-group class="input-group-search">
                    <b-input-group-prepend>
                  <!-- <font-awesome-icon icon="search" /> -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M23.663 21.9767L19.2137 17.56C20.9408 15.4049 21.7771 12.6695 21.5508 9.91628C21.3245 7.16303 20.0528 4.60118 17.997 2.75751C15.9412 0.913839 13.2578 -0.0715191 10.4983 0.00404582C7.73893 0.0796108 5.11331 1.21035 3.16137 3.16377C1.20944 5.11719 0.0795504 7.74481 0.00404275 10.5063C-0.0714649 13.2678 0.913145 15.9534 2.75542 18.0107C4.59769 20.068 7.15759 21.3407 9.90875 21.5672C12.6599 21.7937 15.3932 20.9567 17.5466 19.2283L21.96 23.645C22.0715 23.7575 22.2042 23.8468 22.3503 23.9077C22.4964 23.9686 22.6532 24 22.8115 24C22.9698 24 23.1266 23.9686 23.2727 23.9077C23.4189 23.8468 23.5515 23.7575 23.663 23.645C23.8792 23.4212 24 23.1221 24 22.8108C24 22.4996 23.8792 22.2005 23.663 21.9767ZM10.8186 19.2283C9.15827 19.2283 7.53518 18.7355 6.15463 17.8124C4.77408 16.8892 3.69807 15.5771 3.06267 14.0419C2.42727 12.5068 2.26102 10.8175 2.58495 9.18784C2.90887 7.55813 3.70842 6.06115 4.88248 4.88619C6.05654 3.71124 7.55239 2.91108 9.18086 2.58691C10.8093 2.26274 12.4973 2.42912 14.0313 3.065C15.5653 3.70088 16.8764 4.77771 17.7988 6.15931C18.7213 7.54091 19.2137 9.16523 19.2137 10.8269C19.2137 13.0551 18.3292 15.192 16.7548 16.7675C15.1804 18.3431 13.0451 19.2283 10.8186 19.2283Z" fill="#62626B"/>
                </svg>
                </b-input-group-prepend>
                <b-form-input type="search" :placeholder="$t('parameters.search.search')" v-model="filter" class="search-field" @input="searchFilter($event)"> 
                </b-form-input>
              </b-input-group> 
              </b-input-group>
              <b-button title="exportFile" variant="light" class="invisible-button" @click="exportFile">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 27 27" fill="none">
              <path d="M8.5 25.9999H18.5C22.035 25.9999 23.8038 25.9999 24.9013 24.9024C26 23.8024 26 22.0362 26 18.4999V17.2499C26 13.7149 26 11.9474 24.9013 10.8487C23.9413 9.88869 22.4687 9.76744 19.75 9.75244M7.25 9.75244C4.53125 9.76744 3.05875 9.88869 2.09875 10.8487C1 11.9474 1 13.7149 1 17.2499V18.4999C1 22.0362 1 23.8037 2.09875 24.9024C2.47375 25.2774 2.92625 25.5237 3.5 25.6862" stroke="#62626B" stroke-width="2" stroke-linecap="round"/>
              <path d="M13.5 1V17.25M13.5 17.25L9.75 12.875M13.5 17.25L17.25 12.875" stroke="#62626B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
              </b-button>
              </b-row>
            </b-col>
            </b-row>
    
          </div>
          <div class="col-sm-12 list-container">
            <div align="center" class="cards">
            <!-- <div id="table-wrapper-subscribers"> -->
          <VuePerfectScrollbar ref="ps-chapters" class="table-wrapper">
          <b-table thead-top 
                  show-empty
                  class="tableFixHead"
                  v-model="tableValues" 
                  per-page="0"
                  :busy="isBusy"
                  id="table-list-lives"
                   :items="registrants" 
                  :fields="fields" 
                  :current-page="currentPage"
                  tbody-tr-class="custom-row"
                  >
                  <template slot="HEAD_check" slot-scope="head">
                    {{ head.label }}
                  </template>
                  <template slot="id" slot-scope="row">
        
                      <span>{{ row.item.id }} </span>
                  </template>
                  <template slot="nom" slot-scope="row">
                    <span>{{ row.item.name }} {{ row.item.last_name }}</span>
                  
                  </template>
                  <template slot="email" slot-scope="row">
                    <span>{{ row.item.webtvSubscriptionUser.email }}  </span>
                  
                  </template>
                  <template slot="entreprise" slot-scope="row">
                    <span>{{ row.item.webtvSubscriptionUser.society }}  </span>
                  
                  </template>
                  <template slot="date" slot-scope="row">
                    <span>{{ row.item.created_at | moment(' DD/MM/YYYY ') }} </span>
                    <span>( {{ row.item.created_at | moment('HH:mm') }} )</span>
                  </template>
                  <template slot="participation" slot-scope="row">
                    <span :class="{'is_Participated': row.item.is_participated, 'not_Participated': !row.item.is_participated}">
                      {{ row.item.is_participated ? $t('modal.view.params.yes') : $t('modal.view.params.no') }}
                     </span>
                  
                  </template>
                  <template slot="empty" slot-scope="scope" class="my-5 text-center">
                    <div class="my-5 text-center">{{ $t('table.empty') }}</div>
                  </template>
                  <div slot="table-busy" class="my-5 text-center">
                    <b-spinner class="align-middle"
                      style="width: 1.5rem;height: 1.5rem;border: 0.15em solid currentColor;border-right-color: transparent;margin-right: 10px;color: grey;"></b-spinner>
                    <span class="spinner">Data loading...</span>
                  </div>

                </b-table>
            </VuePerfectScrollbar>
              <!-- </div> -->
                <div class="p-15 border-top"
                style="padding-inline: 0;margin-top: 15 !important;"
                >
                <b-row>
                  <b-col class="d-none d-md-flex justify-content-start align-items-center">
              <b-pagination v-model="currentPage" :total-rows="this.filteredRecord" :per-page="perPage"
                :first-text="String.fromCharCode(171)" :prev-text="String.fromCharCode(60)"
                :next-text="String.fromCharCode(62)" :last-text="String.fromCharCode(187)"
                @change="changeNumPage($event)" class="mb-0 buttons-link "
                :variant="headerBgVariant"></b-pagination>
            </b-col>
            <b-col
              class="d-flex justify-content-start align-items-center position-relative justify-content-end subscibers-pagination">
              <span style="padding-right: 10px">{{ $t('table.pagination.elementPerPage') }}</span>
              <b-form-group class="mb-0"><!--label-cols-sm="3" label="Per page"-->
                <b-form-select v-model="perPage" :options="pageOptions" value-field="item" text-field="name"
                  :aria-selected="perPage" @change="changePerPage($event)"></b-form-select>
              </b-form-group>
              <!-- <span v-if="getTotalLive"> / {{ getTotalLive }}</span>
              <span v-else>/ 0</span> -->
            </b-col>
          </b-row>
              </div>
              </div>
            </div>              
        </b-card>  
    </div>
</template>


<script>
import axios from 'axios';
import VueSelect from 'vue-select';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import 'vue-select/src/scss/vue-select.scss';
import UploadMixin from '../mixins/UploadMixin.js';
import UtilsMixin from '../mixins/UtilsMixin.js';
import { mapGetters, mapActions, mapState } from 'vuex';
import HasPermission from '../directives/HasPermission.js';
import VueMoment from 'vue-moment';
import * as moment from 'moment';
// import common from '../helpers/common';
import NProgress from 'nprogress';
import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';

export default {
  name: 'ExportLive',
  mixins: [UploadMixin, UtilsMixin],
  components:{
  VuePerfectScrollbar,
  VueMoment,
  moment,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  directives: {
    HasPermission,
  },
  data(){
    return {
        registrants: [],
        currentPage: 1,
        searchWord: '', 
        perPage: 20,
        recordTotal:0,
        filteredRecord:0,
        isBusy:false,
        pageOptions: [
        { item: '5', name: '5' },
        { item: '10', name: '10' },
        { item: '20', name: '20' },
      ],
    }
  },
  computed:{
    ...mapGetters({
      isPermission: 'common/getPermission',
      isSuperAdmin: 'common/getSuperAdmin',
      getDiffusion: 'common/getDiffusion',

    }),

    fields() {
      return [

        {
          key: 'id',
          id: '0',
          label: i18n.t('table.list.idInscrit'),
          sortable: false,
          class: 'd-lg-table-cell w-80px custom-thead-class',
        },
        {
          key: 'nom',
          id: '1',
          label: i18n.t('table.list.nom'),
          sortable: false,
          class: ' d-lg-table-cell custom-thead-class',
        },
        {
          key: 'email',
          id: '2',
          label: i18n.t('table.list.email'),
          sortable: false,
          class: 'd-md-table-cell custom-thead-class',
        },
        {
          key: 'entreprise',
          id: '3',
          label: i18n.t('table.list.entreprise'),
          sortable: false,
          class: 'd-none d-md-table-cell custom-thead-class',
        },
        {
          key: 'date',
          id: '4',
          label: i18n.t('table.list.date'),
          sortable: false,
          class: 'd-none d-lg-table-cell custom-thead-class',
        },
        {
          key: 'participation',
          id: '5',
          label: i18n.t('table.list.participation'),
          sortable: false,
          class: 'd-none d-md-table-cell  custom-thead-class',
        },
      ];
    },
  },
  watch:{

  },
  methods:{
    ...mapActions({
      setDiffusionObject: 'lives/setDiffusionObject',
      paginate: 'lives/paginate',
      setLoading:'lives/setLoading'

    }),
    goToListLive() {
      parent.postMessage(
        {
          info: 'goToListLive',
          value: this.getDiffusion,
        },
        '*',
      );
      const cryptext = this.$route.query;
      this.$router.push({ name: 'ListLive', query: cryptext });
    },
    exportFile() {
  if (this.$route.params.id) {
    if (this.recordTotal === 0) {
      const msg = i18n.t('toast.export_empty');
      this.showToast('error', msg, 'icon-warning');
      return; 
    }

    NProgress.start();
        axios
          .get(
            `${window.process.env.API_HOST_GLOBAL}/live/subscriptions/subscribers/exportExcelSubscribersByLiveId/${this.$route.params.id}`,
            {
              headers: {
                Authorization: `Bearer ${process.env.API_TOKEN}`,
              },
            }
          )
          .then((response) => {
            const messageSuccess = i18n.t('toast.export_success');
            const binaryData = atob(response.data.data);
          const byteArray = new Uint8Array(binaryData.length);
          for (let i = 0; i < binaryData.length; i++) {
            byteArray[i] = binaryData.charCodeAt(i);
          }
          const blob = new Blob([byteArray]);
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = blobUrl;
          a.download = "subscribers.xlsx";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(a);
          NProgress.done();
          this.showToast('success',messageSuccess, 'icon-success');
          })
          .catch((error) => {
            const message = i18n.t('toast.export_Error');
            this.showToast('error',message, 'icon-warning');
          });
      }
    },

    fetchRegistrants() {
      if(this.$route.params.id)
    {  
      this.isBusy=true
      // this.setLoading({ type: 'videos', value: true }); // Set loading to true before API call
      axios.get(
        `${window.process.env.API_HOST_GLOBAL}/live/subscriptions/subscribers/GetSubscribersByLiveId/${this.$route.params.id}`,
        // `https://a748-41-230-33-70.ngrok-free.app/live/subscriptions/subscribers/GetSubscribersByLiveId/${this.$route.params.id}`,
        {
          params: {
            searchWord: this.searchWord,
            length: this.perPage,
            page: this.currentPage
          },
          headers: {
            Authorization: `Bearer ${process.env.API_TOKEN}`
          },
        },
      )
        .then((res) => {
          this.registrants = res.data.subscribers;
          this.recordTotal = res.data.recordsTotal;
          this.filteredRecord = res.data.recordsFiltered;
          this.isBusy=false
          // this.setLoading({ type: 'videos', value: false }); // Set loading to false after API call
        
        });}
    },
    setTotalRows(number) {
      this.recordTotal = number;
    },

    changePerPage(event) {
      this.perPage = event;
      this.currentPage = 1;
      this.fetchRegistrants(); 
  },
   
    changeNumPage(page) {
    this.currentPage = page;
    this.fetchRegistrants(); 
  },
  searchFilter(event) {

    this.searchWord = event;
    this.currentPage = 1; 
    this.fetchRegistrants(); 
  },

  },
  created(){
    this.fetchRegistrants();
  },
  async mounted(){
    this.setTotalRows(this.filteredRecord);
  }

};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_theme.scss';
@import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';
@import 'vue-multiselect/dist/vue-multiselect.min.css';


.main-container{
 overflow: hidden;
 min-height: 100vh;
}
.Export-container{
  margin: 12px 15px 0px 15px;
  // padding-inline: 0px;
  border-radius: 15px;
  border: 1.5px solid #E4E5E9;

}
.Header{
  padding-inline: 20px;
  padding-bottom: 5px;
}
.header-title{
  color: #6B6B89;
text-align: center;
font-family: 'Roboto', Helvetica, Arial, sans-serif;
font-size: 22px;
font-style: normal;
font-weight: 500;
line-height: normal;
}
.invisible-button{
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: none;
  height: 39px;
  width: 39px;
  border: 1px solid #E4E5E9;
  padding: 6px;
  border-radius: 10px;
}
.custom-row{

  text-align: center;
font-family: Roboto;
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: normal;
text-align: center;
height: 4rem;
vertical-align: middle;
  cursor: pointer;
  transition: .5s all ease-in-out;
  td{
    height: 4rem;
    vertical-align: middle;
  }
}
.custom-row:hover{
  color: #1890FF;

}
.custom-thead-class {
  color: #77777C !important;
  opacity: .7;
  text-align: center;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  height: 3.5rem;
  th{
    vertical-align: middle;
  }

}
.custom-thead-tr-class th {
  height: 80px; /* Set the desired height for th elements */
  background-color: #f0f0f0; /* Set the background color for th elements */
  /* Add any other styles as needed */
}
.is_Participated{
  color:#09D01D;
}
.not_Participated{
  color:#ED2939;
}

.table-wrapper {
  height: 100%;
  height: calc(100vh - 190px);
  overflow: auto;

  #table-list-lives ::v-deep {
    thead th {
      position: sticky;
      top: -1px;
      z-index: 1;
      box-shadow: inset 0 -1px #dee2e6;
      border-bottom: none;
    }

    th {
      background-color: #efefef;
    }

    .actions-td {
      min-width: 170px;
    }
  }
}

#table-wrapper-subscribers {
  height: 100%;
  height: calc(100vh - 190px);
  overflow-x: hidden;
  overflow-y: hidden;
  &::-webkit-scrollbar {
  width: 5px;
}

/* Track */
&::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
&::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
&::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
  }
  .list-container {
    padding-inline: 0;
    height: calc(100vh - 190px);

    .cards {
      padding: 0;
    }
  }
  .card-body{
    padding-inline:0px;
  }
.subscibers-pagination{
    .custom-select{
      border:none;
    }
  }
  ::v-deep .table > thead > tr > th {
  color: #77777C !important;
  text-align: center;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 3.5rem;
  vertical-align: middle;
  }
  ::v-deep .table > tbody > tr > td {
    height: 5.5rem;
    vertical-align: middle;
    text-align: center;
   
}
::v-deep .table > tbody > tr:hover{
      color: #1890FF;
    }
#table-list-lives ::v-deep {
  td {
    position: relative;

    @media screen and (max-width: 360px) {
      padding: 0.75rem 0 0.75rem 0.75rem;
    }
  }

  .actions-cell {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    vertical-align: middle;
    align-items: center;
    flex-wrap: wrap;
  }

  .live-content {
    &__thumbnail-container {
      flex: 1 0 0;
      margin-right: 1em;
    }

    &__data {
      flex: 1 0 0;
      position: relative;

      &__title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* number of lines to show */
        -webkit-box-orient: vertical;
        /*word-break: break-word;*/
        word-break: break-word;
        overflow-wrap: break-word;
      }

      h4 {
        font-size: 1em;
        margin-bottom: 0;

        @media screen and (max-width: 360px) {
          font-size: 0.8em;
        }
      }

      p {
        color: #777777;
        line-height: 1.2em !important;
        font-size: 80%;
        font-weight: 400;
      }

      &__date {
        font-size: 0.8em;
        font-weight: 600;
        color: #555555;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 0;
        width: 100%;
        margin-top: 0.2em;

        @media screen and (max-width: 360px) {
          font-size: 0.7em;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: left;
          text-align: left;
          width: auto;
        }
      }
    }
  }

 
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
 
  #table-list-lives{
    height: 100%;
  height: calc(100vh - 190px);
  overflow: auto;
  }
}

.right-content{
  gap: 10px;
}
.input-search {
    position: relative;

    .filter-wrapper {
      position: absolute;
      top: 100%;
      background-color: #ffffff;
      width: 100%;
      padding: 20px;
      z-index: 2;
      margin-top: 5px;
      border-radius: 2px;
      box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14),
        0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
    }
    .search-field{
      border: none;
    }
    .input-group-search {
      align-items: center !important;
      border-radius: 10px;
      border: 1px solid #E4E5E9;
    }
    .input-group-prepend{
      font-size: 20px;
       color: grey;
       padding-inline: 7px;
    }
  }
  .border-top{
    margin-top: 15px;
  }
  .spinner:hover{
    color:grey;
  }

</style>



// WEBPACK FOOTER //
// src/components/ExportRegistrant.vue